import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Copy({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Copy</title>
      <path
        d="M6 21C4.34315 21 3 19.6569 3 18L3 10C3 8.34315 4.34315 7 6 7L14 7C15.6569 7 17 8.34315 17 10L17 18C17 19.6569 15.6569 21 14 21L6 21Z"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 3L18 3C19.6569 3 21 4.34315 21 6L21 17"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
